import React from 'react';

import {
  ActionsCell,
  NameCell,
  SortCell,
  TagsCell,
} from '../../../../shared/components/DataTable';
import { DROPDOWN_ACTIONS } from '../../constants';
import { formatDate } from '../../utils';

const nameColumn = {
  accessorKey: 'fullName',
  cell: ({ row }) => <NameCell person={row.original} />,
  header: ({ column }) => <SortCell column={column} label="Name" />,
  meta: { className: 'w-full' },
};

const tagsColumn = {
  accessorKey: 'tags',
  cell: ({ getValue }) => <TagsCell tags={getValue()} />,
  header: 'Tags',
  meta: { className: 'min-w-48 text-right' },
};

const ownerColumn = {
  accessorKey: 'owner.fullName',
  cell: ({ row }) => row.original.owner && <NameCell person={row.original.owner} />,
  header: ({ column }) => <SortCell column={column} label="Owner" />,
  meta: { className: 'min-w-48' },
};

const addedAtColumn = {
  accessorKey: 'addedAt',
  cell: ({ getValue }) => formatDate(getValue()),
  header: ({ column }) => <SortCell column={column} label="Added" />,
  meta: { className: 'min-w-32' },
};

const actionsColumn = {
  cell: () => <ActionsCell actions={DROPDOWN_ACTIONS.decedent} />,
  id: 'actions',
};

const columns = [nameColumn, tagsColumn, ownerColumn, addedAtColumn, actionsColumn];

export default columns;
